import React from 'react';
import { Carousel, Tag, message, Button } from 'antd';
import ActivityService from '../../../services/activity.service';
import { blobToUrlImage, getStatusIcon } from '../../../utils/utils';
import defaultImage from '../../../assets/default.jpg';
import { Map, Marker, Tooltip, TileLayer, GeoJSON } from 'react-leaflet'
import { mapUrl, getIconMarker } from '../../../utils/map';
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';
import './activity.scss';
import { guarico } from '../../../utils/guarico';


class Activity extends React.Component {

  state = {
    activity: this.props.activity,
    urlPhotos: [],
    showMap: false,
    postpone: false,
    showViewer: false
  }

  componentWillUpdate(props) {
    console.log(props);
  }

  renderMap = () => {
    const position = [this.props.activity.lat, this.props.activity.lng]
    const map = (
      <Map center={position} zoom={8}>
        <TileLayer
          url={mapUrl}
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        <GeoJSON key="guarico-limits" data={guarico} />
        <Marker icon={getIconMarker(this.props.activity.status)} position={position}>
          <Tooltip>{this.props.activity.title}</Tooltip>
        </Marker>
      </Map>
    )
    return map;
  }

  setDefaultPhotos = () => {
    const { photos } = this.state.activity;

    if (photos.length > 0) {
      this.setState({
        urlPhotos: photos.map(photos => <img alt="default" src={defaultImage} width="100%" height="100%"></img>)
      })
    } else {
      this.setState({
        urlPhotos: [<img alt="default" src={defaultImage} width="100%" height="100%"></img>],
        showMap: true
      })
    }
  }

  componentDidMount() {
    this.setDefaultPhotos();
    this.downloadPhotos(this.state.activity);
  }

  downloadPhotos = async (activity) => {
    const { photos } = activity;
    if (!photos) return;
    try {
      const listOfPhotos = photos.map(photo =>
        ActivityService.getPhoto(photo)
      );
      const resolvedPhotos = await Promise.all(listOfPhotos);

      const urlPhotos = resolvedPhotos.map(photo => {
        return blobToUrlImage(photo.data);
      });

      this.setState({
        urlPhotos
      });
    } catch (error) {
      message.error(error.toString());
    }
  }

  onSlideChange = (e) => {
    console.log(e);
  }

  switchMapOrPhotos = () => {
    this.setState((state) => ({ showMap: !state.showMap }));
  }

  render() {
    const { activity, showMap } = this.state;
    return (
      <div className="modal-container">
        <div className="carousel">
          <Button className="true-carousel" icon="fullscreen" onClick={() => this.setState({ showViewer: true })} />
          {showMap ?
            <div>
              <div >{this.renderMap()}</div>
            </div>
            :
            <Carousel afterChange={this.onSlideChange} infinite autoplay={true} adaptiveHeight={true} >
              {
                this.state.urlPhotos.map((photo, i) =>
                  (
                    <div key={i} className="carousel-stage">
                      <img src={photo} height="449px" width="100%" alt="Foto obra"></img>
                    </div>
                  )
                )
              }
            </Carousel>
          }
          <Viewer
            images={this.state.urlPhotos.map(photo => ({ src: photo, alt: '' }))}
            onClose={() => this.setState({ showViewer: false })}
            visible={this.state.showViewer} />
        </div>
        <div className="content">

          <div className="content-header">
            <span className="title">{activity.title}</span>
            <div className="date-container">
              <div id="date-span">{activity.dayOfWeek} {activity.date}</div>
            </div>
          </div>

          <div className="content-body">
            {activity.content}
          </div>

          < div className="content-footer">
            <div className="action-item">
              <Tag color={activity.governor_present ? '#2d9213a6' : '#7c7c7c'} >
                {activity.governor_present ? 'Con asistencia del Gobernador' : 'Sin asistencia del Gobernador'}
              </Tag>
            </div>
            <div className="action-item">
              {getStatusIcon(activity.status)}
            </div>
            <div className="action-item">
              {this.state.activity.photos.length > 0 && <Tag onClick={this.switchMapOrPhotos} >{showMap ? 'Fotos' : 'Mapa'}</Tag>}
            </div>
          </div>

        </div>
      </div >
    )
  }

}

export default Activity;